import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const bonusSystemRoutes = [
    {
        path: '/Settings/BonusSystem/Operations',
        component: React.lazy(() => import('./BonusOperationsPage')),
        auth: authRoles.admin,
        accessPageName: 'BONUSSYSTEM',
    },
    {
        path: '/Settings/BonusSystem',
        component: React.lazy(() => import('./BonusSystemPage')),
        auth: authRoles.admin,
        accessPageName: 'BONUSSYSTEM',
    },
]

export default bonusSystemRoutes
